import moment from "moment-timezone";

const getTimezone = () => {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return timeZone;
  } catch (error) {
    console.error("Error retrieving timezone:", error);
  }
};

export const dateFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD MMMM YYYY") : "";
};

export const dayFormat = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD") : "";
};

export const yearFormat = (date) => {
  const timezone = getTimezone();
  const targetDate = date ? moment(date) : moment();
  return targetDate.tz(timezone).format("YYYY");
};

// in utc

export const dateFormatUtc = (date) => {
  const timezone = getTimezone();
  return date
    ? moment(date).tz(timezone).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
    : "";
};

export const dateFormatWithTime = (date) => {
  const timezone = getTimezone();
  return date ? moment(date).tz(timezone).format("DD MMM YYYY, hh:mm A") : "";
};

export const month = () => {
  return [
    { name: "January", value: "1" },
    { name: "February", value: "2" },
    { name: "March", value: "3" },
    { name: "April", value: "4" },
    { name: "May", value: "5" },
    { name: "June", value: "6" },
    { name: "July", value: "7" },
    { name: "August", value: "8" },
    { name: "September", value: "9" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
  ];
};

export const formatToDDMMYYYY = (isoDate) => {
  if (!isoDate) return "";
  return moment(isoDate).format("DD-MM-YYYY");
};

export const toDate = (date) => {
  return moment(date).toDate();
};

export const toIsoDate = (dateStr) => {   
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) {
    return "";
  }
  return date.toISOString();
};

/// Function to get the start of the day from a date

export const getStartDay = (date) => { 
  if (!date) return null;
  return moment(date).startOf("day").toDate();
};

// Function to get the end of the day from a date

export const getEndDay = (date) => {
  if (!date) return null;
  return moment(date).endOf("day").toDate();
};

// Start of the selected day (local) as a UTC ISO string - use for startDate payloads

export const toUtcStartOfDay = (date) => {
  if (!date) return "";
  const parsed = moment(date);
  return parsed.isValid() ? parsed.startOf("day").toISOString() : "";
};

// End of the selected day (local) as a UTC ISO string - use for endDate payloads

export const toUtcEndOfDay = (date) => {
  if (!date) return "";
  const parsed = moment(date);
  return parsed.isValid() ? parsed.endOf("day").toISOString() : "";
};

// Function to check if endDate is greater than startDate

export const isEndDateGreater = (startDate, endDate) => {
  if (!startDate || !endDate) return false;

  const start = getEndDay(startDate);
  const end = moment(endDate).toDate();

  return moment(end).isAfter(start);
};
// -----------Output: 20 Apr, 2023----------
export const dateStringFormat = (date) => {
  if (!date) return null;
  return moment(date).format('DD MMM, YYYY');
};

export const formatCustomDate = (date, outputFormat = 'YYYY-MM-DD HH:mm') => {
  if (!date) return '';
  return moment(date).format(outputFormat);
};